export enum ModalIds {
  AgencySwitcherModal = 'agency-switcher-modal',
  NoActiveAgencyModal = 'no-active-agency-modal',
  MfaConfirmationModal = 'mfa-confirmation-modal',
  GotMandateModal = 'got-mandate-modal',
  NotGotMandateModal = 'not-got-mandate-modal',
  NotSoldModal = 'not-sold-modal',
  PropertySoldModal = 'property-sold-modal',
  ExportCsvModal = 'export-csv-modal',
  BulkPromotionModal = 'bulk-promotion-modal',
  ResetMfaModal = 'reset-mfa-modal',
}

export interface ModalActionPayload {
  id: ModalIds;
  options?: Record<string, any>;
}

export interface Modal {
  id: string;
  isOpen: boolean;
  options?: Record<string, any>;
}
